import {
  MENU_TOGGLE,
  SIDER_TOGGLE,
  GET_CONFIG_PENDING,
  GET_CONFIG_SUCCES,
  GET_CONFIG_FAILURE,
} from "./mainTypes";

export const initialState = {
  menuIsCollapsed: localStorage.getItem("menuState") === "false" ? false : true,
  siderIsCollapsed: true,
  config: {},
};

const mainReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case MENU_TOGGLE:
      localStorage.setItem("menuState", (!state.menuIsCollapsed).toString());
      return {
        ...state,
        menuIsCollapsed: !state.menuIsCollapsed,
      };
    case SIDER_TOGGLE:
      return {
        ...state,
        siderIsCollapsed: !state.siderIsCollapsed,
      };
    case GET_CONFIG_PENDING:
      return {
        ...state,
        configLoading: true,
      };
    case GET_CONFIG_SUCCES:
      return {
        ...state,
        config: action.data,
        configLoading: false,
      };
    case GET_CONFIG_FAILURE:
      return {
        ...state,
        configLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default mainReducer;
